// extracted by css-extract-rspack-plugin
export default {"EmbeddingOptionIcon":"mk0rc","Disabled":"L_rzA"};